import { Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * DeleteModal Component - Migrated to EDS Dialog
 * 
 * Phase 5: EDS Migration
 * 
 * This component has been migrated from styled-components modal
 * to the EDS Dialog component.
 * 
 * Legacy props maintained for backward compatibility:
 * - visible: boolean - Controls whether the dialog is shown
 * - onOk: function - Called when the confirm button is clicked
 * - onCancel: function - Called when the cancel button is clicked
 * - okText: string - Text for the confirm button
 * - cancelText: string - Text for the cancel button
 * - title: string - Dialog title
 * - content: string - Dialog content (supports HTML)
 * - img: boolean - Whether to show the trash icon
 * - buttonColor: string - Color for the confirm button
 */

function getButtonVariant(buttonColor) {
  if (buttonColor === "#ef4949") return "destructive";
  if (buttonColor === "#007cc5") return "default";
  if (buttonColor === "#f0c46d") return "outline";
  return "default";
}

function DeleteModal(props) {
  const { visible, onOk, onCancel, okText, cancelText, title, content, img, buttonColor } = props;
  
  const buttonVariant = getButtonVariant(buttonColor);
  const isWarning = buttonColor === "#f0c46d";
  
  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onCancel?.()}>
      <DialogContent 
        className="sm:max-w-[350px]" 
        showCloseButton={false}
      >
        <DialogHeader className="items-center text-center">
          {img && (
            <div className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-destructive text-white">
              <Trash2 className="h-4 w-4" />
            </div>
          )}
          <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
          <DialogDescription asChild>
            <div
              className="text-center text-sm"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-row justify-center gap-2.5 sm:justify-center">
          <Button
            variant="outline"
            onClick={onCancel}
            className="min-w-[80px] border-teal-500 text-teal-500 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-600"
          >
            {cancelText}
          </Button>
          <Button
            variant={buttonVariant}
            onClick={onOk}
            className={`min-w-[80px] ${isWarning ? "bg-warning-500 text-foreground text-white hover:bg-warning-600 hover:text-white" : ""}`}
          >
            {okText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteModal;
